import { render, staticRenderFns } from "./Thumbnails.vue?vue&type=template&id=ded1ce12&lang=pug"
import script from "./Thumbnails.vue?vue&type=script&lang=js"
export * from "./Thumbnails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports